// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimsTeamOrganizationDto } from './IClaimsTeamOrganizationDto';
import {
    IClaimsTeamOrganizationDtoFromJSON,
    IClaimsTeamOrganizationDtoFromJSONTyped,
    IClaimsTeamOrganizationDtoToJSON,
    IClaimsTeamOrganizationDtoToJSONTyped,
} from './IClaimsTeamOrganizationDto';
import type { IClaimsTeamContactDto } from './IClaimsTeamContactDto';
import {
    IClaimsTeamContactDtoFromJSON,
    IClaimsTeamContactDtoFromJSONTyped,
    IClaimsTeamContactDtoToJSON,
    IClaimsTeamContactDtoToJSONTyped,
} from './IClaimsTeamContactDto';

/**
 * 
 * @export
 * @interface IClaimsTeamInfoDto
 */
export interface IClaimsTeamInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimsTeamInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamInfoDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimsTeamInfoDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamInfoDto
     */
    org_path?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof IClaimsTeamInfoDto
     */
    allowed_services?: Array<number>;
    /**
     * 
     * @type {Array<IClaimsTeamOrganizationDto>}
     * @memberof IClaimsTeamInfoDto
     */
    assigned_organizations?: Array<IClaimsTeamOrganizationDto>;
    /**
     * 
     * @type {Array<IClaimsTeamContactDto>}
     * @memberof IClaimsTeamInfoDto
     */
    assigned_contacts?: Array<IClaimsTeamContactDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimsTeamInfoDto
     */
    is_generic_claims_team?: boolean;
}

/**
 * Check if a given object implements the IClaimsTeamInfoDto interface.
 */
export function instanceOfIClaimsTeamInfoDto(value: object): value is IClaimsTeamInfoDto {
    return true;
}

export function IClaimsTeamInfoDtoFromJSON(json: any): IClaimsTeamInfoDto {
    return IClaimsTeamInfoDtoFromJSONTyped(json, false);
}

export function IClaimsTeamInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsTeamInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'org_path': json['org_path'] == null ? undefined : json['org_path'],
        'allowed_services': json['allowed_services'] == null ? undefined : json['allowed_services'],
        'assigned_organizations': json['assigned_organizations'] == null ? undefined : ((json['assigned_organizations'] as Array<any>).map(IClaimsTeamOrganizationDtoFromJSON)),
        'assigned_contacts': json['assigned_contacts'] == null ? undefined : ((json['assigned_contacts'] as Array<any>).map(IClaimsTeamContactDtoFromJSON)),
        'is_generic_claims_team': json['is_generic_claims_team'] == null ? undefined : json['is_generic_claims_team'],
    };
}

export function IClaimsTeamInfoDtoToJSON(json: any): IClaimsTeamInfoDto {
    return IClaimsTeamInfoDtoToJSONTyped(json, false);
}

export function IClaimsTeamInfoDtoToJSONTyped(value?: IClaimsTeamInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'organization_id': value['organization_id'],
        'org_path': value['org_path'],
        'allowed_services': value['allowed_services'],
        'assigned_organizations': value['assigned_organizations'] == null ? undefined : ((value['assigned_organizations'] as Array<any>).map(IClaimsTeamOrganizationDtoToJSON)),
        'assigned_contacts': value['assigned_contacts'] == null ? undefined : ((value['assigned_contacts'] as Array<any>).map(IClaimsTeamContactDtoToJSON)),
        'is_generic_claims_team': value['is_generic_claims_team'],
    };
}

